import axios from "axios";

// Development Local Server
// const api = axios.create({
//   baseURL: "http://localhost:8000/mobo",
// });

const api = axios.create({
  baseURL: "https://api.eatitgo.com/mobo",
  withCredentials: true,
});

// depoyloyment
// const api = axios.create({
//   baseURL: "/mobo",
//   withCredentials: true,
// });


export default api;
